import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const cloneAdminEventReducer = createReducer<State, Actions>(initialState, {
  [actions.cloneAdminEvent.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.cloneAdminEvent.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.cloneAdminEvent.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.cloneAdminEvent.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default cloneAdminEventReducer;
